import script from "./toricCalculate.vue?vue&type=script&setup=true&lang=js"
export * from "./toricCalculate.vue?vue&type=script&setup=true&lang=js"

import "./toricCalculate.vue?vue&type=style&index=0&id=7f63ec54&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f63ec54"]])

export default __exports__